module.exports = __webpack_public_path__ + "images/usermodule/03@2x.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/03@2x.gif
// module id = 1573
// module chunks = 4